import { render } from "./Onduty.vue?vue&type=template&id=3495c1ba&scoped=true"
import script from "./Onduty.vue?vue&type=script&lang=js"
export * from "./Onduty.vue?vue&type=script&lang=js"

import "./Onduty.vue?vue&type=style&index=0&id=3495c1ba&lang=less&scoped=true"
import "./Onduty.vue?vue&type=style&index=1&id=3495c1ba&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3495c1ba"]])

export default __exports__